import React, { useEffect, useState } from "react";
import { Col, Divider, Image, Row, Tabs } from "antd";
import styled from "styled-components";

import { useParams } from "react-router-dom";
import { getSingleProperty } from "../api/propertyApi";
import { FaBath, FaBed, FaTelegramPlane, FaWhatsapp } from "react-icons/fa";
import { MailOutlined } from "@ant-design/icons";
import { EMAIL, PHONE_NUMBER, TELE_USERNAME } from "../envVar";
import { convertFromRaw, EditorState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";

const PropertyPageContainer = styled.div`
  width: 80%;
  height: 85vh;
  margin: 0 auto;
  background-color: #fff;
`;

const Text = styled.p`
  font-size: 16px;
`;

const MediaGalleryContainer = styled.div`
  height: 85vh;
  overflow-y: auto;
  padding: 1px;
`;

const GalleryRow = styled(Row)``;

const GalleryItem = styled(Col)`
  padding: 1px;
`;

const Column2Header = styled(Row)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  margin: 0;
  font-size: 20px;
  font-weight: 900;
`;

const Column2Container = styled.div`
  height: 85vh;
  padding: 5px;
  border-color: white;
  border-left-color: #c7c7c7;
  /* border-width: 5px; */
  border-style: solid;
`;

const Column2Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
  padding: 5px;
`;

const Column2ContentComponentsRow = styled(Row)`
  padding: 10px;
  width: 100%;
`;

const CustomText = styled(Text)`
  margin: 10px 0;
  padding: 0px;
`;

const SocialMediaIcons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  /* margin-top: 10px; */
  padding: 10px;

  & > * {
    margin-right: 10px;
    font-size: 30px;
    color: ${(props) => props.iconColor};
    cursor: pointer;
    transition: color 0.3s;

    &:hover {
      color: #000000;
    }
  }
`;

const CustomDivider = styled(Divider)`
  margin: 10px 0;
  border-color: #bebebe;
`;

const PropertyPage = () => {
  const { id } = useParams();
  const [property, setPropertyData] = useState("");
  const [descriptionEditorState, setDescriptionEditorState] = useState("");

  const fetchPropertyData = async () => {
    const data = await getSingleProperty(id);
    console.log(data);
    setPropertyData(data);
  };

  useEffect(() => {
    fetchPropertyData();
  }, []);

  const handleWhatsAppClick = () => {
    // no along yusmi = 60138141575
    const phoneNumber = PHONE_NUMBER;
    const propertyUrl = window.location.href;
    const message = `Hi Yusmie, Saya berminat dengan hartanah ini -> ${propertyUrl}`;
    const waLink = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(
      message
    )}`;
    window.open(waLink);
  };

  const handleTelegramClick = () => {
    const teleUsername = TELE_USERNAME;
    window.location.href = `https://t.me/${teleUsername}`;
  };

  const handleEmailClick = () => {
    // email along yusmie = damascusyt@yahoo.com
    const email = EMAIL;
    window.location.href = `mailto:${email}?subject=Property Inquiry&body=I'm interested in the property. Please provide me with more information.`;
  };

  const getGalleryRows = () => {
    const { images } = property;
    const galleryRows = [];

    let rowIndex = 0;
    let imageIndex = 0;

    while (imageIndex < images.length) {
      const galleryItems = [];

      if (rowIndex === 0) {
        galleryItems.push(
          <GalleryItem xs={24} key={imageIndex}>
            <Image
              src={images[imageIndex].url}
              alt={images[imageIndex].title}
              preview
              width="100%"
            />
          </GalleryItem>
        );
        imageIndex++;
      } else if (rowIndex === 1) {
        for (let i = 0; i < 2 && imageIndex < images.length; i++) {
          galleryItems.push(
            <GalleryItem xs={12} key={imageIndex}>
              <Image
                src={images[imageIndex].url}
                alt={images[imageIndex].title}
                preview
                width="100%"
              />
            </GalleryItem>
          );
          imageIndex++;
        }
      } else {
        for (let i = 0; i < 3 && imageIndex < images.length; i++) {
          galleryItems.push(
            <GalleryItem xs={8} key={imageIndex}>
              <Image
                src={images[imageIndex].url}
                alt={images[imageIndex].title}
                preview
                width="100%"
              />
            </GalleryItem>
          );
          imageIndex++;
          rowIndex = -1;
        }
      }

      galleryRows.push(<GalleryRow key={rowIndex}>{galleryItems}</GalleryRow>);

      rowIndex++;
    }

    return galleryRows;
  };

  const TabItems = [
    {
      key: "1",
      label: `Diskripsi`,
      children: property && (
        <Editor editorState={descriptionEditorState} toolbarHidden={true} />
      ),
    },
    {
      key: "2",
      label: `Google Maps`,
      children: (
        <div
          style={{ borderRadius: "10px", height: "350px", maxHeight: "400px" }}
        >
          <iframe
            title="Google Map"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            src={`https://www.google.com/maps?q=${encodeURIComponent(
              property.location?.replace(/^[^,]+,\s*/, "")
            )}&output=embed`}
            allowFullScreen
          ></iframe>
        </div>
      ),
    },
  ];

  const TabsOnChange = (key) => {
    console.log(key);
  };

  useEffect(() => {
    if (property.description) {
      const contentState = convertFromRaw({
        ...property.description,
        entityMap: property.description.entityMap || {},
      });
      const editorState =
        contentState && EditorState.createWithContent(contentState);
      setDescriptionEditorState(editorState);
    }
  }, [property.description]);

  return (
    property && (
      <PropertyPageContainer>
        <Row style={{ height: "100%" }} align="top" justify="center">
          <Col span={12} style={{ padding: "0px" }}>
            <MediaGalleryContainer>{getGalleryRows()}</MediaGalleryContainer>
          </Col>
          <Col span={12}>
            <Column2Container>
              <Column2Header>AY</Column2Header>
              <CustomDivider />
              <Column2Content>
                <Column2ContentComponentsRow align="top">
                  <Col span={24} style={{ display: "flex" }}>
                    <Text
                      strong
                      style={{
                        fontSize: "35px",
                        fontWeight: "800",
                        padding: "0px",
                        margin: "0",
                        marginRight: "5px",
                      }}
                    >
                      RM {property.price}
                    </Text>
                    <Text style={{ display: "flex", alignItems: "end" }}>
                      {property.amenities.bathroom}
                      <FaBed style={{ marginLeft: "2px" }} />
                      <Divider
                        type="vertical"
                        style={{ color: "black", borderColor: "#868686" }}
                      />
                      {property.amenities.bedroom}
                      <FaBath />
                    </Text>
                  </Col>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <CustomText
                      style={{
                        fontSize: "30px",
                        fontWeight: "700",
                        color: "#ff7777",
                      }}
                    >
                      {property.sellingPoint}
                    </CustomText>
                    <CustomText>{property.location}</CustomText>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                      }}
                    >
                      <CustomText>Hubungi Kami:</CustomText>
                      <SocialMediaIcons iconColor="#006aff">
                        <FaWhatsapp onClick={handleWhatsAppClick} />
                        <MailOutlined onClick={handleEmailClick} />
                        <FaTelegramPlane onClick={handleTelegramClick} />
                      </SocialMediaIcons>
                    </div>
                  </div>
                </Column2ContentComponentsRow>
                <CustomDivider />
                <Column2ContentComponentsRow>
                  <Col span={24}>
                    <Tabs
                      style={{ width: "100%" }}
                      defaultActiveKey="1"
                      items={TabItems}
                      onChange={TabsOnChange}
                    />
                  </Col>
                </Column2ContentComponentsRow>
              </Column2Content>
            </Column2Container>
          </Col>
        </Row>
      </PropertyPageContainer>
    )
  );
};

export default PropertyPage;
